import { render, staticRenderFns } from "./TagDeleteModal.vue?vue&type=template&id=5ac76e8b&"
import script from "./TagDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./TagDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./TagDeleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports